import { render, staticRenderFns } from "./adduser.vue?vue&type=template&id=1c30ac78&scoped=true&"
import script from "./adduser.vue?vue&type=script&lang=js&"
export * from "./adduser.vue?vue&type=script&lang=js&"
import style0 from "./adduser.vue?vue&type=style&index=0&id=1c30ac78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c30ac78",
  null
  
)

export default component.exports